import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Router } from 'wouter';
import App from './App.jsx';

import '@mantine/core/styles.css';

const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  headings: {
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontWeight: '900',
  },
});

createRoot(document.getElementById('root')).render(
  <MantineProvider theme={theme} defaultColorScheme="auto">
    <Router>
      <App />
    </Router>
  </MantineProvider>
);
